export default __webpack_public_path__ + "media/images/manual/ic/08-3887a613f563ba36361843d81f23a613.png";